import formName from 'constants/formName'
import { actions, selectors } from 'data'
import { connect, ConnectedProps } from 'react-redux'

import { PropsType as _P } from '../template'
import ListAddresses from './template'

export type PropsType = _P & ConnectedProps<typeof connector>

const mapStateToProps = (state) => ({
  addresses: selectors.payments.getWhitelistAddresses(state),
  twoFactorStatus: selectors.auth.getTwoFactorStatus(state)
})

const mapDispatchToProps = (dispatch) => ({
  resetForm: () => {
    dispatch(actions.form.reset(formName.WHITELIST_ADDRESS))
  },
  setAddressToDelete: (id: string) => {
    dispatch(actions.form.change(formName.WHITELIST_ADDRESS, 'addressToDelete', id))
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(ListAddresses)
